$(".product_media_zoom").on("mouseover", function() {
  $(this).children(".image-zoom").css({
   transform: "scale(" + $(this).attr("data-scale") + ")" 
  });
}).on("mouseout", function() {
  $(this).children(".image-zoom").css({
   transform: "scale(1)" });
}).on("mousemove", function(e) {
  $(this).children(".image-zoom").css({
   "transform-origin":
     ((e.pageX - $(this).offset().left) / $(this).width()) * 100 +
     "% " +
     ((e.pageY - $(this).offset().top) / $(this).width()) * 100 +
     "%"
  });
}); 

/* Gallery arrow fix (Oct 2026): replaces the theme's conflicting arrow logic.
   Next on the last image wraps to the first; previous on the first wraps to the last. */
(function () {
  function unlock() {
    document.querySelectorAll('slider-component').forEach(function (sc) {
      if (sc.tagName !== 'SLIDER-COMPONENT') return;
      sc.enableSliderLooping = true;
      sc.querySelectorAll('.slider-button').forEach(function (b) { b.removeAttribute('disabled'); });
    });
  }
  unlock();
  window.addEventListener('load', unlock);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.slider-button');
    if (!btn) return;
    var sc = btn.closest('slider-component');
    if (!sc) return;
    var s = sc.querySelector('[id^="Slider-"]');
    if (!s) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var items = Array.prototype.filter.call(sc.querySelectorAll('[id^="Slide-"]'), function (el) { return el.clientWidth > 0; });
    if (items.length < 2) return;
    var offset = items[1].offsetLeft - items[0].offsetLeft;
    var step = parseInt(btn.dataset.step || '1', 10);
    var max = s.scrollWidth - s.clientWidth;
    var pos;
    if (btn.name === 'next') {
      pos = (s.scrollLeft >= max - 5) ? 0 : s.scrollLeft + step * offset;
    } else {
      pos = (s.scrollLeft <= 5) ? max : s.scrollLeft - step * offset;
    }
    s.scrollTo({ left: Math.max(0, Math.min(pos, max)) });
  }, true);
})();
